/** Dedicated single-purpose copy of StockCountSchedule's "Counting UOMs" tab (Demo Mode nav
 * restructure) - same component as the original tabbed page's tab two, rendered as its own
 * standalone screen instead of one of three tabs on a shared page. The original tabbed page
 * (index.tsx, route /stock-count-schedule/:tab) is untouched and remains the production
 * entry point. */

import { Box } from '@mui/material';
import CountingUOMBox from './components/CountingUomsBox';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';

const StockCountUomsPage = () => {
  const { t } = useTranslation('common');

  return (
    <Box sx={{ width: '100%', textAlign: 'left' }}>
      <PageArea>
        <PageTitle>{t('stockCountUoms', 'Stock Count UOMs')}</PageTitle>
        <CountingUOMBox />
      </PageArea>
    </Box>
  );
};

export default StockCountUomsPage;
